import axios from "axios";

import { ApiService } from "../../servicios/api.service";
import LocalStorageKeys from "../../data/localStorageKeys";

export class BeneficioApi {
  static endPoint = "admin/beneficio/";

  static get BasePath() {
    return ApiService.api + this.endPoint;
  }

  static get AuthHeader() {
    return "Token " + localStorage.getItem(LocalStorageKeys.token);
  }

  static get Headers() {
    return { Authorization: this.AuthHeader };
  }

  static get Config() {
    return { headers: this.Headers };
  }

  static approve(id) {
    return axios.put(this.BasePath + id + "/aprobar", {}, this.Config);
  }

  static countWithFilter(filter) {
    return axios.post(this.BasePath + "filter/count", filter, this.Config);
  }

  static countUsaCodigosWithFilter(filter) {
    return axios.post(this.BasePath + "utiliza-codigos/filter/count", filter, this.Config);
  }

  static create(data) {
    return axios.post(this.BasePath, data, this.Config);
  }

  static deleteById(id) {
    return axios.delete(this.BasePath + id, this.Config);
  }

  static getListWithFilter(filter) {
    return axios.post(this.BasePath + "filter/", filter, this.Config);
  }

  static getListUsaCodigosWithFilter(filter) {
    return axios.post(this.BasePath + "utiliza-codigos/filter/", filter, this.Config);
  }

  static getTipoDescuentoList() {
    return axios.get(ApiService.api + "tiposdescuentos/", this.Config);
  }

  static getUnidadesDescuentoList() {
    return axios.get(ApiService.api + "descuentos/unidades/admin", this.Config);
  }

  static reject(id) {
    return axios.put(this.BasePath + id + "/rechazar", {}, this.Config);
  }

  static update(data) {
    return axios.put(this.BasePath, data, this.Config);
  }

  static uploadLogo(beneficioId, formData) {
    return axios.post(
      ApiService.api + "uploads/logos/beneficios/" + beneficioId,
      formData,
      {
        headers: {
          Authorization: this.AuthHeader,
          "Content-Type": "multipart/form-data"
        }
      }
    );
  }

  static getTiposCodigo() {
    return axios.get(ApiService.api + "tiposcodigo/", this.Config);
  }

  static getCsvCodigos(body) {
    body.codigos = [];
    return axios.post(ApiService.api + "codigos/beneficio/exportar-csv", body, this.Config);
  }

}
